import * as Sentry from "@sentry/react";
import { isStagingHost } from "src/utils/apiUrl";
import { scrubToken } from "src/utils/scrubToken";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const IP_DENY = ["forwarded", "-ip", "remote-", "via", "-user"];

// Mirror the runtime API URL logic so the same artifact reports as "staging"
// from the staging slot and "production" from betonijerry.fi after a swap.
// VITE_SENTRY_ENVIRONMENT remains as an explicit override for edge cases.
function detectEnvironment() {
    const override = import.meta.env.VITE_SENTRY_ENVIRONMENT;
    if (override) return override;
    if (typeof window !== "undefined") {
        const host = window.location?.hostname;
        if (host === "localhost" || host === "127.0.0.1") return "development";
        if (isStagingHost(host)) return "staging";
        return "production";
    }
    return import.meta.env.MODE || "development";
}

if (dsn) {
    Sentry.init({
        dsn,
        environment: detectEnvironment(),
        // Sentry v11 replaced sendDefaultPii with dataCollection, whose
        // defaults collect MORE; this is v10's `sendDefaultPii: false`
        // (Sentry migration-guide baseline, same as @ibetoni/constants/sentry).
        dataCollection: {
            userInfo: false,
            cookies: false,
            httpHeaders: { request: { deny: IP_DENY }, response: { deny: IP_DENY } },
            httpBodies: [],
            urlQueryParams: { deny: IP_DENY },
            genAI: { inputs: false, outputs: false },
            databaseQueryData: false,
            graphQL: { document: false, variables: false },
        },
        tracesSampleRate: 0,
        beforeSend(event) {
            const breadcrumbs = event.breadcrumbs?.map((b) => {
                if (b.data?.request_headers?.Authorization) {
                    b.data.request_headers.Authorization = "[redacted]";
                }
                return b;
            });
            if (breadcrumbs) event.breadcrumbs = breadcrumbs;
            // Strip the preview-page capability token (?token=<jwt>) so it
            // never lands in a Sentry event's request URL.
            if (event.request?.url) event.request.url = scrubToken(event.request.url);
            return event;
        },
    });
}
